export enum FeedbackGroupQuestionReportKeys {
  feedbackGroupQuestionReport_downloadAsPDFTooltip = "feedbackGroupQuestionReport_downloadAsPDFTooltip",
  feedbackIndividualView_emailTableHeader = "feedbackIndividualView_emailTableHeader",
  feedbackIndividualView_nameTableHeader = "feedbackIndividualView_nameTableHeader",
  feedbackIndividualView_actionsTableHeader = " feedbackIndividualView_actionsTableHeader",
  feedbackIndividualView_viewReportLink = " feedbackIndividualView_viewReportLink",
  feedbackIndividualView_positionTableHeader = " feedbackIndividualView_positionTableHeader",
  feedbackIndividualView_lastUpdatedTableHeader = " feedbackIndividualView_lastUpdatedTableHeader",
  feedbackReport_currentReportTab = "feedbackReport_currentReportTab",
  feedbackReport_behaviouralChangeReportTab = "feedbackReport_behaviouralChangeReportTab",
  feedbackReport_newTag = "feedbackReport_newTag",
  feedbackReport_vsLabel = "feedbackReport_vsLabel",
  feedbackReport_changeSelectionButton = "feedbackReport_changeSelectionButton",
  feedbackReport_noPreviousCampaignsFound = "feedbackReport_noPreviousCampaignsFound",
  feedbackReport_compareButton = "feedbackReport_compareButton",
  feedbackReport_selectTeamFromLeft = "feedbackReport_selectTeamFromLeft",
  feedbackReport_statusTableHeader = "feedbackReport_statusTableHeader",
  feedbackReport_teamTableHeader = "feedbackReport_teamTableHeader",
  feedbackReport_somethingWentWrong = "feedbackReport_somethingWentWrong",
  feedbackReport_oopsInvalidSurveyCampaign = "feedbackReport_oopsInvalidSurveyCampaign",
}
